import cn from "classnames";
import React from "react";
import styles from "src/components/animate/animate.module.css";
import { useInView } from "react-intersection-observer";

export const AnimateRevealDown: React.FC<{
  className?: string;
  children: React.ReactNode;
}> = (props) => {
  const className = cn(styles.down, props.className);

  return <div className={className}>{props.children}</div>;
};

export const AnimateRevealUpScroll: React.FC<{
  className?: string;
  children: React.ReactNode;
}> = (props) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const className = cn(styles.up, props.className, !inView && styles.off);

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
};
